import dayjs from "dayjs";
import {FieldCreateFormInputType} from "./fieldValidationUtils";

const DEFAULT_SOIL_ID = "0";
const DEFAULT_CROP_ID = "2000";
const DEFAULT_IRRIGATION_ID = "0";

export const PNG_HOST = import.meta.env.VITE_APP_PNG_ENDPOINT as string;

export const FIELD_INITIAL_VALUES: FieldCreateFormInputType = {
    name: "New Field",
    soilId: DEFAULT_SOIL_ID,
    irrigationTypeId: DEFAULT_IRRIGATION_ID,
    farmId: null,
    orderId: null,
    priority: false,
    KSATBias: 1,
    satSoilMoistBias: 1,

    irrigationInterval: null,
    desiredMoistureLevel: null,
    irrigationCriteria: null,
    irrigationDefault: null,
    onFarmEfficiencyMin: null,
    minAppliedWater: null,
    maxAppliedWater: null,
    cropCycles: [
        {
            cropId: DEFAULT_CROP_ID,
            plantedDate: dayjs(),
            estHarvestDate: null,
            actHarvestDate: null,
            effRootDepth: null,
            droughtSensitivity: 3,
            variety: "",
            resetCropCycle: true,
            resetETAppliedWater: true,
            resetRootDepth: true,
        },
    ],
};

export const DEFAULT_SUGGESTED_PRICE_PER_HA_EUR = 13;

// Demo Company - Metahara Sugar Factory
export const DEMO_COMPANY_ID = "018ead72-8aaf-7bdb-88b2-b8ca301b045a";
